var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,index){return _c('alert-snackbar',{key:("alert-" + index),attrs:{"globalMessage":error,"type":"error"},on:{"dismissed":_vm.onDismissed}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }